<template>
  <div class="propertyCreditScoreSystem">
   <!-- 添加表格 -->
    <el-card>
      <el-button type="primary" slot="header" @click="jump()">{{$t('lang.btn_returnlab_levelList')}}</el-button>
      <!-- 文本跟随传入的id显示 -->
      <el-button
        type="primary"
        slot="header"
        @click="addReview()"
        v-if="this.oneEvaluationLevel === '1'"
      >{{$t('lang.btn_addpraise')}}</el-button>
      <el-button
        type="primary"
        slot="header"
        @click="addReview()"
        v-if="this.oneEvaluationLevel === '2'"
      >{{$t('lang.btn_addaverage')}}</el-button>
      <el-button
        type="primary"
        slot="header"
        @click="addReview()"
        v-if="this.oneEvaluationLevel === '3'"
      >{{$t('lang.btn_addbed')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
      <!-- checkbox -->
        <el-table-column
          type="selection"
          width="55"
          v-if="propertyCreditScoreSystemEvaluationcheckbox"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <!-- 是否显示 -->
        <el-table-column prop="twoEvaluation" :label="$t('lang.evaluationDisplay')"></el-table-column>
        <el-table-column :label="$t('lang.display')" width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.flag === 1">{{$t('lang.yes')}}</span>
            <span v-if="scope.row.flag === 0">{{$t('lang.no')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="changeReview(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deletetable(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <!-- 添加弹窗 -->
      <el-dialog
        :title="titleShow"
        :visible.sync="diaIsShow"
        :close-on-click-modal="false"
        center
        top="130px"
        width="600px"
        @closed="handleDialogClosed"
        @submit.native.prevent
      >
      <!-- 表单验证 -->
        <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <!-- 是否显示 -->
          <el-form-item :label="$t('lang.display')" prop="radio">
            <el-radio v-model="form.radio" label="1">{{$t('lang.diaplay_true')}}</el-radio>
            <el-radio v-model="form.radio" label="0">{{$t('lang.display_false')}}</el-radio>
          </el-form-item>
          <!-- 评价评语 -->
          <el-form-item :label="$t('lang.reviews')" prop="input">
            <el-input v-model="form.input" :placeholder="$t('lang.pleaseEnterContent')"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
          <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:communityManagement
 *@Description:物业信用积分体系
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-02-26
 */
export default {
  // 默认显示数据
  data() {
    return {
      titleShow: '', // 弹框标题
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      btnName: '', // 按钮名称
      editId: '', // 接收传参
      tableData: [], // 表单数据
      pageCount: 0, // 总页数
      pageSize: 10, // 每页显示数量
      pageNo: 1, // 页数
      oneEvaluationLevel: '', // 参数
      twoEvaluation: '', // 评价
      flag: '1', // 显示
      multipleSelection: [], // 多选框
      diaIsShow: false, // 弹框是否显示
      // 表单验证
      form: {
        radio: 1,
        input: '',
        flags: true
      },
      rules: {
        input: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_plea_review'),
            trigger: 'blur'
          }
        ]
      },
      propertyCreditScoreSystemEvaluationcheckbox: require('@/config/enum').propertyCreditScoreSystemEvaluationcheckbox // 是否隐藏复选框
    }
  },
  // 接收详情页面传入的参数
  created() {
    this.oneEvaluationLevel = this.$route.query.id
    this.getById()
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    commit() {
      this.pageNo = 1
      this.getById()
    },
    // 显示页面
    getById() {
      let loading = this.$loading()
      this.$get(
        `/getEvaluationDetailByGrade?pageSize=${this.pageSize}&pageNo=${this.pageNo}&disPlay=${this.flag}&grade=${this.oneEvaluationLevel}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 跳转回详情页面
    jump() {
      this.$router.push({ name: 'propertyCreditScoreDetails' })
    },
    // 删除评价
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`delEvaluationDetailById/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 添加评价
    addReview() {
      if (this.oneEvaluationLevel === '1') {
        this.titleShow = this.$i18n.t('lang.btn_addpraise')
      } else if (this.oneEvaluationLevel === '2') {
        this.titleShow = this.$i18n.t('lang.btn_addaverage')
      } else if (this.oneEvaluationLevel === '3') {
        this.titleShow = this.$i18n.t('lang.btn_addbed')
      }
      this.editId = ''
      this.form.input = ''
      this.form.radio = '1'
      this.diaIsShow = true
    },
    // 修改评价
    changeReview(id) {
      if (this.oneEvaluationLevel === '1') {
        this.titleShow = this.$i18n.t('lang.btn_changepraise')
      } else if (this.oneEvaluationLevel === '2') {
        this.titleShow = this.$i18n.t('lang.btn_changeaverage')
      } else if (this.oneEvaluationLevel === '3') {
        this.titleShow = this.$i18n.t('lang.btn_changebed')
      }
      this.editId = id
      let loading = this.$loading()
      this.$get(`/getEvaluationDetailById/` + this.editId).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.radio = res.result.flag.toString()
            this.form.input = res.result.twoEvaluation
            this.saveData = JSON.stringify(this.form)
            this.diaIsShow = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 弹窗保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editId === '') {
            let loading = this.$loading()
            let params = {
              grade: this.oneEvaluationLevel,
              isDisplay: this.form.radio,
              newEvaluationDetail: this.form.input
            }           
            this.$post(`/addEvaluationDetail/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            // let formData = new FormData()
            let flags = true
            if (this.form.flag === '0') {
              flags = false
            }
            let loading = this.$loading()
            let params = {
              isDisplay: this.form.radio,
              newEvaluationDetail: this.form.input,
              flag: flags
            }
            this.$patch(`/editEvaluationDetail/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 弹窗清空
    clear() {
      this.form.input = ''
      this.form.radio = '1'
      this.$refs.form.clearValidate()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getById()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.getById()
    }
  }
}
</script>

<style lang= 'scss'>

</style>